import React from 'react';
import TabCreateView from 'src/components/Layout/TabCreateView';
import DeliveryTab from 'src/components/CreateDuplicateVehicleTracking/DeliveryTab';
import LoadTab from 'src/components/CreateDuplicateVehicleTracking/LoadTab';

function UpdatePlanning({
  deliveryLineItem,
  setDeliveryLineItem,
  loadLineItem,
  setLoadLineItem,
  organisationId,
  vehicleTrackingNumber,
  selectedStep,
  setSelectedStep,
  totalSteps,
}) {
  const addEditDeliveryAndLoadComponents = [
    {
      id: 1,
      title: 'Delivery',
      component: (
        <DeliveryTab
          deliveryLineItem={deliveryLineItem}
          setDeliveryLineItem={setDeliveryLineItem}
          organisationId={organisationId}
          vehicleTrackingNumber={vehicleTrackingNumber}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          totalSteps={totalSteps}
        />
      ),
    },
    {
      id: 2,
      title: 'Load',
      component: (
        <LoadTab
          deliveryLineItem={deliveryLineItem}
          loadLineItem={loadLineItem}
          setLoadLineItem={setLoadLineItem}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          totalSteps={totalSteps}
        />
      ),
    },
  ];

  return (
    <div className="duplicate-tracking-placeholder">
      <TabCreateView
        createLeadFormComponents={addEditDeliveryAndLoadComponents}
      />
    </div>
  );
}

export default UpdatePlanning;
